import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { updateFilters } from "../redux/activitiesSaga";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

export const Dropdown = ({ placeholder, sliceKey }) => {
  const { [sliceKey]: allOptions } = useSelector((state) => state.activities.filters);
  const { [sliceKey]: selectedOptions } = useSelector((state) => state.activities.selectedFilters);

  const dispatch = useDispatch();

  const onSelectChange = (data) => {
    dispatch(updateFilters({ [sliceKey]: data }));
  };

  return (
    <MultiSelectDropdown
      options={allOptions}
      selectedFilters={selectedOptions}
      placeholder={placeholder}
      numberDisplayed={0}
      includeSelectAll
      enableOnly
      onSelectChange={onSelectChange}
    />
  );
};
